import { z } from 'zod';
export const EmployeePaySlipsSearchSchema = z.object({
  /**
   * 一覧の検索文字列。明細番号・対象期間・支給日に前方一致ではなく部分一致で当てる。
   * ツールバーの入力を戻る / 共有で再現できるよう search param で持つ。
   */
  freeText: z.string().optional(),
  /**
   * 詳細 drawer で開いている給与明細レコード。未指定なら drawer は閉じている。
   * 帳票一覧（従業員 × 期間）の行クリックから特定期間の明細を開いた状態へディープリンクするため、
   * ローカル state ではなく search param で持つ。
   */
  recordId: z.string().optional()
});
export const EmployeeWageLedgerSearchSchema = z.object({
  /**
   * 詳細サイドパネルで開いている賃金台帳 1 冊（`事業場:従業員:年`）。未指定ならパネルは閉じている。
   * 帳票一覧から特定の冊を開いた状態へディープリンクできるよう search param で持つ。
   */
  ledgerId: z.string().optional()
});